
<template>
  <div>
    <Navbar></Navbar>
    <div class="dashboard mx-5">
      <h1 class="mt-3">Übersicht</h1>
      <template>
        <v-layout align-start row fill-height class="ml-1 mb-5">
          <ApolloQuery :query="require('../graphql/totalCoupons.gql')">
            <template v-slot="{ result: { loading, error, data } }">
              <!-- Loading -->
              <div v-if="loading" class="loading apollo">Loading...</div>

              <!-- Error -->
              <div v-else-if="error" class="error apollo">An error occurred</div>
              <div v-else-if="data" class="result apollo">
                <div v-for="sum in data.getSumOfCoupons" :key="sum.total">
                  <!-- Result -->
                  <v-card class="mx-auto mt-5 mr-3" width="344">
                    <v-card-text>
                      <div>
                        <h3>Betrag aller Gutscheine:</h3>
                      </div>
                      <div class="mt-5">
                        <h1>{{ sum.total }} €</h1>
                      </div>
                    </v-card-text>
                  </v-card>
                </div>
              </div>
            </template>
          </ApolloQuery>

          <ApolloQuery :query="require('../graphql/getFileCount.gql')">
            <template v-slot=" { result: { loading, error, data } }">
              <!-- Loading -->
              <div v-if="loading" class="loading apollo">Loading...</div>

              <!-- Error -->
              <div v-else-if="error" class="error apollo">An error occurred</div>
              <div v-else-if="data" class="result apollo">
                <!-- Result -->
                <v-card class="mx-auto mt-5 ml-3" width="344">
                  <v-card-text>
                    <div>
                      <h3>zum Upload bereit:</h3>
                    </div>
                    <div class="mt-5">
                      <h1>{{ data.getFileCount }}</h1>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </template>
          </ApolloQuery>
        </v-layout>
      </template>
      <ApolloQuery
        :query="gql => gql`
        query {
          coupons {
            id
            filename
            gnr
            name
            price

          }
        }
      `"
      >
        <template v-slot="{ result: { loading, error, data } }">
          <!-- Loading -->
          <div v-if="loading" class="loading apollo">Loading...</div>

          <!-- Error -->
          <div v-else-if="error" class="error apollo">An error occurred</div>

          <!-- Result -->
          <div v-else-if="data">
            <!-- <div v-for="coupon in data.coupons" :key="coupon.id">{{ coupon.gnr }}, {{coupon.name}}, {{ coupon.price }}</div> -->
            <v-data-table
              :headers="headers"
              :items="data.coupons"
              :search="search"
              :footer-props="{itemsPerPageOptions: [5, 10,15,120,700,-1]}"
              class="elevation-1"
            >
              <template v-slot:top>
                <v-toolbar flat color="white">
                  <v-toolbar-title>Alle Gutscheine</v-toolbar-title>
                  <v-divider class="mx-4" inset vertical></v-divider>
                  <div class="flex-grow-1"></div>
                  <v-text-field v-model="search" label="Search" class="mx-4 mt-5 pt-2"></v-text-field>
                  <!-- Add Coupon -->
                  <v-btn
                    v-on:click="dialog = true, editedIndex=-1"
                    class="mb-2"
                    color="green"
                    outlined
                    small
                    fab
                  >
                    <v-icon>mdi-plus</v-icon>
                  </v-btn>

                  <!-- Download File -->

                  <v-btn
                    class="mb-2 mx-2"
                    color="orange"
                    outlined
                    small
                    fab
                    @click="downloadPDF()"
                  >
                    <v-icon>mdi-download</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-dialog v-model="dialog" max-width="800px">
                  <v-card class="py-4 px-4">
                    <ApolloMutation
                      :mutation="require('../graphql/createCoupon.gql')"
                      :variables="{gnr, name, price}"
                      :update="updateTable"
                      @done="onDone"
                    >
                      <template slot-scope="{ mutate, loading, error }">
                        <!-- Loading -->
                        <h4 v-if="loading">The mutation is loading!</h4>

                        <!-- Error -->
                        <p v-if="error">An error has occurred!</p>
                        <v-card-title>
                          <span class="headline">{{ formTitle }}</span>
                        </v-card-title>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="gnr" label="Gutscheinnummer"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="name" label="Name"></v-text-field>
                              </v-col>
                              <v-col cols="12" sm="6" md="4">
                                <v-text-field v-model="price" label="Preis"></v-text-field>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <div class="flex-grow-1"></div>
                          <v-btn color="blue darken-1" text @click="close">Abbrechen</v-btn>
                          <!-- Mutation Trigger -->
                          <template v-if="editedIndex == -1">
                            <v-btn color="green" outlined @click="mutate()">
                              <v-icon left>mdi-plus</v-icon>Hinzufügen
                            </v-btn>
                          </template>
                          <template v-else-if="editedIndex == 0">
                            <v-btn
                              color="green"
                              outlined
                              @click="updateCoupon(id, gnr, name, price)"
                            >
                              <v-icon left>mdi-pencil</v-icon>Bearbeiten
                            </v-btn>
                          </template>
                        </v-card-actions>
                      </template>
                    </ApolloMutation>
                  </v-card>
                </v-dialog>
              </template>
              <template v-slot:item.action="{ item }">
                <v-icon small class="mr-2" @click="editItem(item)">mdi-pencil</v-icon>
                <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
              </template>
              <template v-slot:item.gnr="{item}">
                <v-chip :color="getColor(item.gnr)">{{ item.gnr }}</v-chip>
              </template>
              <template v-slot:item.name="{item}">
                <v-chip :color="getColor(item.name)">{{ item.name }}</v-chip>
              </template>
              <template v-slot:item.price="{item}">
                <v-chip :color="getColor(item.price)">{{ item.price }}</v-chip>
              </template>
            </v-data-table>
          </div>
          <!-- No result -->
          <div v-else class="no-result apollo">No result :(</div>
        </template>
      </ApolloQuery>
    </div>
  </div>
</template>


<script>
import Navbar from "@/components/Navbar";
import COUPONS_ALL from "../graphql/allCoupons.gql";
import COUPON_UPDATE from "../graphql/updateCoupon.gql";
import axios from "axios";
import moment from "moment";
import 'moment/locale/de';

export default {
  components: { Navbar },
  data: () => ({
    name: "",
    price: "",
    gnr: "",
    id: "",
    dialog: false,
    search: "",
    path: "",
    headers: [
      {
        text: "id",
        align: "left",
        sortable: false,
        value: "id"
      },
      {
        text: "Dateiname",
        value: "filename"
      },
      { text: "Gutscheinnummer", value: "gnr" },
      { text: "Name", value: "name" },
      { text: "Preis", value: "price" },
      { text: "Actions", value: "action", sortable: false }
    ],
    editedIndex: -1
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1
        ? "Neuer Gutschein"
        : "Gutschein bearbeiten";
    }
  },

  // Check status of modal (closed/opend), when beeing closed, clear fields
  watch: {
    dialog(val) {
      if (val == false) {
        this.clearDialog();
        !val;
      }
    }
  },

  methods: {
    async downloadPDF() {
      axios({
        url: "http://localhost:4000/api/invoice",
        method: "GET",
        responseType: "blob"
      }).then(response => {
        var fileURL = window.URL.createObjectURL(new Blob([response.data]));
        var fileLink = document.createElement("a");
        fileLink.href = fileURL;
        console.log(moment.locale());
        var fileName =
          "Rechnung-" + moment().locale('de').format("DD-MM-YYYY-HH-mm-ss") + ".pdf";
        fileLink.setAttribute("download", fileName);
        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },
    getColor(test) {
      console.log(test);
      if (Number(test) == 0) {
        console.log("red");
        return "red";
      }

      if (typeof test === "string" || test instanceof String) {
        if (test.endsWith("NOT FOUND")) {
          console.log("red");
          return "red";
        }
      }
      if (Number(test) % 1 !== 0) {
        return "transparent";
      } else return "transparent";
    },

    //clear modal
    clearDialog() {
      this.gnr = "";
      this.name = "";
      this.price = "";
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.gnr = "";
        this.name = "";
        this.price = "";
        alert("test");
      }, 300);
    },

    // after Mutation console log done
    onDone() {
      console.log("done");
    },

    //Update Cache after Mutation ( adding new item )
    updateTable(store, { data: { createCoupon } }) {
      {
        const data = store.readQuery({ query: COUPONS_ALL });
        data.coupons.push(createCoupon);
        store.writeQuery({ query: COUPONS_ALL, data });
      }
    },

    // Editing Item get values from item ( table row )
    editItem(item) {
      this.editedIndex = 0;
      console.log(item);
      this.id = item.id;
      console.log(this.id);
      this.gnr = item.gnr;
      this.name = item.name;
      this.price = item.price;
      this.dialog = true;
    },
    updateCoupon() {
      console.log("ID:" + this.id);
      const id = this.id;
      const gnr = this.gnr;
      const name = this.name;
      const price = parseFloat(this.price);

      this.$apollo.mutate({
        mutation: COUPON_UPDATE,
        variables: {
          id,
          gnr,
          name,
          price
        }
      });
      this.dialog = false;
    }
  },
  downloadPdf() {
    console.log("Download PDF");
  }
};
</script>

